<ng-container
  kendoTooltip
  class="tooltip"
  [tooltipWidth]="400"
  filter="mat-card"
>
  <mat-card
    class="mat-elevation-z4"
    [ngClass]="{
      'companyCoverage': companyTacticTechniqueCoverage,
      'coverage': cyborgTacticTechniqueCoverage,
      'noCoverage': !cyborgTacticTechniqueCoverage
    }"
    [title]="toolTipString"
  >
    <p *ngIf="count; else elseBlock" [matMenuTriggerFor]="menu">
      {{ child.name.replace('/', ' ') }}<br />({{ count }})
    </p>
    <ng-template #elseBlock>
      <p [matMenuTriggerFor]="menu">{{ child.name.replace('/', ' ') }}</p>
    </ng-template>
  </mat-card>

  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="onFilter(child.name)">
      Apply as Filter
    </button>
    <ng-container *ngIf="sub_techniques_array.length > 0">
      <button mat-menu-item [matMenuTriggerFor]="subMenu">
        Sub-Techniques
      </button>
    </ng-container>
  </mat-menu>

  <mat-menu #subMenu="matMenu">
    <ng-container *ngFor="let sub of sub_techniques_array; trackBy: trackByFn">
      <button mat-menu-item (click)="onFilter(sub.key)">
        {{ sub.key }} ({{ sub.doc_count }})
      </button>
    </ng-container>
  </mat-menu>
</ng-container>
